<div id="publication" class="timeline-card-container" (contextmenu)="onContextMenu($event)">
  <div class="timeline-card" data-testid="card" (click)="onCardClick()">
    <!-- Icon Column -->
    <div class="card-icon">
      <svg width="100%" height="100%" viewBox="0 0 192 192">
        <defs>
          <style>
            .cls-1, .cls-2, .cls-3 { fill: none; } 
            .cls-1 { stroke: #1482fa; } 
            .cls-1, .cls-2 { stroke-linecap: round; stroke-linejoin: round; stroke-width: 8px; } 
            .cls-2 { stroke: #0b41cd; }
          </style>
        </defs>
        <path d="M140.61,48.84H120.47a12.06,12.06,0,0,1-12.08-12V13.72" class="cls-1"></path>
        <path d="M143.63,67.27V51.71a8,8,0,0,0-2-5.27l-27.83-32a8.11,8.11,0,0,0-6.05-2.76H34.88A12.06,12.06,0,0,0,22.8,23.75h0V168.25A12.07,12.07,0,0,0,34.88,180.3h96.67a12.07,12.07,0,0,0,12.08-12.05V94" class="cls-2"></path>
        <path d="M165.35,58.9h0a9.12,9.12,0,0,1,0,12.91l-2.85,2.85h0L149.56,61.75h0l2.86-2.85a9.16,9.16,0,0,1,12.93,0Z" class="cls-1"></path>
        <polyline points="163.51 76.67 169.21 82.35 138.71 112.79" class="cls-1"></polyline>
        <polygon points="149.57 61.75 73.94 137.23 69.22 154.86 86.89 150.12 162.51 74.67 149.57 61.75 149.57 61.75 149.57 61.75" class="cls-2"></polygon>
        <line x1="73.94" y1="137.23" x2="86.89" y2="150.12" class="cls-2"></line>
        <rect width="192" height="192" class="cls-3"></rect>
      </svg>
    </div>
    
    <!-- Content Column -->
    <div class="card-content">
      <!-- Status Tag (Always at top-right) -->
      <div class="status-container">
        <span class="status-tag" 
              [class.status-in-progress]="publication.metadata.status === 'In Progress'"
              [class.status-published]="publication.metadata.status === 'Published'"
              [class.status-rejected]="publication.metadata.status === 'Rejected'"
              [class.status-submitted]="publication.metadata.status === 'Submitted'"
              [class.status-accepted]="publication.metadata.status === 'Accepted'"
              [class.status-planned]="publication.metadata.status === 'Planned'"
              [class.status-presented]="publication.metadata.status === 'Presented'">
          {{ publication.metadata.status }}
        </span>
        @if(publication.isVisible == false) {
          <span class="hidden-indicator" title="Hidden">
            <rds-icon namespace="filled" icon="visibility_off"></rds-icon>
          </span>
        }
      </div>
      <!-- Title (Primary element) -->
      <h3 class="card-title truncate-2-lines" 
          data-testid="target" 
          [title]="titleTooltip">
        {{ displayTitle }}
      </h3>
      <p class="card-target truncate-1-line" 
         [title]="targetTooltip">
        {{ displayTarget }}
      </p>
      
      <!-- Flexible Tag Area (Optional) -->
      <div class="tags-container">
        @if (publication.strategicPillars && publication.strategicPillars.length > 0) {
          @for (sp of publication.strategicPillars; track sp) {
            <span class="strategic-pillar-tag" 
                  [style.background-color]="sp.color_code"
      [style.color]="getContrastColor(sp.color_code)"
                  [title]="'Strategic Pillar: ' + sp.title">
              {{ sp.title }}
            </span>
          }
        }
        @if (publication.audiences && publication.audiences.length > 0) {
          @for (aud of publication.audiences; track aud) {
            <span class="veeva-audience-tag"
                  [title]="'Audience: ' + aud.name">
              {{ aud.name }}
            </span>
          }
        }
      </div>
      
      <!-- Document Number -->
      @if(!isViewer) {
        <div class="document-info">
          <span class="document-number">{{ publication.metadata.documentNumber || 'DV - No Document Number' }}</span>
        </div>
      }
      
      <!-- Keywords/Studies -->
      <div class="keywords-container">
        @if(getStudiesWithName().length > 0){
          @for(study of getStudiesWithName(); track study){
            <span class="study-tag" data-testclass="study">{{ study.studyName }}</span>
          }
        }
        @else{
          @for(keyword of publication.keyWords; track keyword){
            <span class="keyword-tag" data-testclass="study">{{ keyword }}</span>
          }
        }
      </div>
    </div>
  </div>
</div>
